module.exports = __webpack_public_path__ + "img/3.eb07980e.jpg";